import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  Box,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ClearIcon from '@mui/icons-material/Clear';
import { useTheme } from '@mui/material/styles';

export const TrafficLightSelector = ({
  label,
  value,
  onChange,
  error,
  helperText,
  style = {},
}) => {
  const theme = useTheme();

  const getColor = (value) => {
    switch (value) {
      case 'GRN':
        return '#408156';
      case 'YLW':
        return '#f5cc17';
      case 'RED':
        return '#bd2a33';
      default:
        return '#8f8f8f';
    }
  };

  const handleClear = () => {
    onChange({ target: { value: '' } });
  };

  return (
    <Box sx={{ flex: '1 1 23%', mb: 2 }}>
      <FormControl fullWidth error={!!error} style={style}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={value}
          onChange={onChange}
          label={label}
          endAdornment={
            <InputAdornment position="end">
              {value && (
                <Tooltip title="Borrar selección" arrow>
                  <IconButton
                    onClick={handleClear}
                    edge="end"
                    sx={{ marginRight: 1 }}
                  >
                    <ClearIcon />
                  </IconButton>
                </Tooltip>
              )}
              <Tooltip
                title={`Estado seleccionado: ${value || 'Ninguno'}`}
                arrow
              >
                <CircleIcon sx={{ color: getColor(value), marginRight: 3 }} />
              </Tooltip>
            </InputAdornment>
          }
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: getColor(value),
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: getColor(value),
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: getColor(value),
            },
          }}
        >
          <MenuItem value="GRN">Verde</MenuItem>
          <MenuItem value="YLW">Amarillo</MenuItem>
          <MenuItem value="RED">Rojo</MenuItem>
        </Select>
        {error && (
          <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
            {helperText || error}
          </Typography>
        )}
      </FormControl>
    </Box>
  );
};
